import React from "react";
import {Container, Row, Col, Image, Button} from "react-bootstrap";
import FadeIn from 'react-fade-in';
import Countdown, { zeroPad } from 'react-countdown';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faEnvelopeOpenText} from '@fortawesome/free-solid-svg-icons';
import {faEdit} from '@fortawesome/free-solid-svg-icons';
 
const renderer = ({ days, hours, minutes, seconds, completed }) => {
    return (
        <Container fluid>
            <Row>
                <Col>
                    <h1 className="white">{zeroPad(days)}</h1>
                    <p className="white">DIAS</p>
                </Col>
                <Col>
                    <h1 className="white">{zeroPad(hours)}</h1>
                    <p className="white">HORAS</p>
                </Col>
                <Col>
                    <h1 className="white">{zeroPad(minutes)}</h1>
                    <p className="white">MINUTOS</p>
                </Col>
                <Col>
                    <h1 className="white">{zeroPad(seconds)}</h1>
                    <p className="white">SEGUNDOS</p>
                </Col>
            </Row>
        </Container>     
    );
};


export const SansabotsCountdown = () => {
	return(
    <Container fluid style={{background:'url(/assets/images/sansabots.png)', backgroundSize: 'auto', width:"100%"}}>     
      <Container className="fablab-container" id="sansabots">
        <FadeIn>
            <Row>
                <Col className="text-center">
                    <Image src="/assets/images/banner-sansabots.png" width="50%"/>
                </Col>
            </Row>

            <Row>
                <Col className="text-center" style={{marginTop: "50px",marginBottom:"50px"}}>
                    <h2 className="white">Inscribe a tu equipo AQUÍ</h2>
                    <Button className="fablab-button" href="https://www.classroom.fablab.usm.cl/mod/choicegroup/view.php?id=199" target="_blank"><FontAwesomeIcon icon={faEdit} className="mr-2"/> INSCRIBIRME</Button>
                </Col>
            </Row>

            <Row>
                <Col className="text-center">
                    <Countdown
                        date={"2023-06-02T23:59:00"}
                        renderer={renderer}
                    />
                </Col>
            </Row>
        
            <Row>
                <Col className="text-center" style={{marginTop: "50px",marginBottom:"50px"}}>
                    <a className="fablab-link moving white" target="_blank" rel="noreferrer" href="/conocenos#contacto">¿No eres de la USM? Contáctanos para un torneo interuniversitario <FontAwesomeIcon className="fablab-button-circle white" icon={faEnvelopeOpenText}/></a>
                </Col>
            </Row>
            
        </FadeIn>
      </Container>
    </Container>
	)
}